import { render, staticRenderFns } from "./CustomerGroups.vue?vue&type=template&id=4ee01f8a&"
import script from "./CustomerGroups.vue?vue&type=script&lang=ts&"
export * from "./CustomerGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports